import React from "react";
import { Card, Col } from "reactstrap";
import AppChatHeader from "./AppChatHeader";
import ChatMessages from "../../Common/RightSidebarChat/ChatMessages";
import SendMessages from "../../Common/RightSidebarChat/SendMessages";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../ReduxToolkit/Store";
import GroupChatHeader from "../../GroupChat/GroupChatContent/GroupChatHeader";

export default function PrivateChatContent() {
  const { isGroup } = useSelector((state: RootState) => state.chat);

  return (
    <Col xxl={9} xl={8} md={7} className="box-col-7">
      <Card className="right-sidebar-chat">
        {isGroup ? <GroupChatHeader /> : <AppChatHeader />}
        <div className="right-sidebar-Chats">
          <div className="msger">
            <ChatMessages />
            <SendMessages />
          </div>
        </div>
      </Card>
    </Col>
  );
}
